<template>


  <div class="customer-usage" v-if="customer">
    <report-usages-list :customer-id="customer?.id" show-no-energy  />
  </div>
</template>

<script>
import ReportUsagesList from "@/components/elements/ReportUsagesList.vue";

export default {
  components: {ReportUsagesList},
  data() {
    return {

    }
  },

  mounted() {

  },

  computed:  {
    customer() {
      return this.$parent.customer
    },

  },

  watch: {
    customer() {
      this.loadData()
    },

  },

  methods: {

  }
}
</script>

<style lang="scss">

</style>
